export default __webpack_public_path__ + "static/media/Group 1389.5a9364e2.svg";